export const ENVS_URL = '/envs';
export const LOG_URL = '/log';
export const BIS_CALLBACK_URL = '/bis-callback';

export const BB_URL = 'https://www.budgetbakers.com';

export const FIS_INIT_CONNECTION_URL = '/v1/init-connection';
